import * as React from 'react';
import { Translate } from '../../../shared/LanguageService';
import LanguageService from '../../../shared/LanguageService';
import { Row, Col, FormControl, FormGroup, ControlLabel, Checkbox, Radio } from 'react-bootstrap';
import DateTime from 'react-datetime';
import { IGrouping } from '../Entities';

interface IStatisticsGroupingProps {
    grouping: IGrouping;
    onChange: (e: any) => void;
    handleChange: (name: string, value: any) => void;
    onGroupingRadioChanged: (e: any) => void;
    onGroupingPeriodRadioChanged: (e: any) => void;
}

const StatisticsGrouping = (props: IStatisticsGroupingProps) => {
    return (
        <Row>
            <Col md={6}>
                <fieldset>
                    <legend>{Translate('statistics/page/fieldset/legend/grouping')}</legend>
                    <Row className="tabular column">
                        <div className="col">
                            <Radio
                                name="grouping.isFirm"
                                checked={props.grouping.isFirm}
                                onChange={props.onGroupingRadioChanged}
                                className="inline"
                            >
                                {Translate('statistics/page/fieldset/grouping/is-firm/label')}
                            </Radio>
                            <Checkbox
                                name="grouping.perUser"
                                checked={props.grouping.perUser}
                                onChange={props.onChange}
                                className="inline"
                            >
                                <span>
                                    {Translate('statistics/page/fieldset/grouping/per-user/label')}
                                </span>
                            </Checkbox>
                        </div>
                        <div className="col">
                            <Radio
                                name="grouping.isPhotographer"
                                checked={props.grouping.isPhotographer}
                                onChange={props.onGroupingRadioChanged}
                            >
                                {Translate(
                                    'statistics/page/fieldset/grouping/is-photographer/label'
                                )}
                            </Radio>
                        </div>
                        <div className="col">
                            <Radio
                                name="grouping.isPeriod"
                                checked={props.grouping.isPeriod}
                                onChange={props.onGroupingRadioChanged}
                            >
                                {Translate('statistics/page/fieldset/grouping/is-period/label')}
                            </Radio>
                        </div>
                    </Row>
                </fieldset>
            </Col>
            <Col md={6}>
                <fieldset>
                    <legend>{Translate('statistics/page/fieldset/legend/grouping')}</legend>
                    <Row>
                        <Col md={4}>
                            <Radio
                                name="grouping.period.periodly"
                                checked={props.grouping.period.periodly}
                                onChange={props.onGroupingPeriodRadioChanged}
                            >
                                {Translate(
                                    'statistics/page/fieldset/grouping/period/periodly/label'
                                )}
                            </Radio>
                        </Col>
                        <Col md={4}>
                            <Radio
                                name="grouping.period.monthly"
                                checked={props.grouping.period.monthly}
                                onChange={props.onGroupingPeriodRadioChanged}
                            >
                                {Translate(
                                    'statistics/page/fieldset/grouping/period/monthly/label'
                                )}
                            </Radio>
                        </Col>
                        <Col md={4}>
                            <Radio
                                name="grouping.period.quarterly"
                                checked={props.grouping.period.quarterly}
                                onChange={props.onGroupingPeriodRadioChanged}
                            >
                                {Translate(
                                    'statistics/page/fieldset/grouping/period/quarterly/label'
                                )}
                            </Radio>
                        </Col>
                    </Row>
                </fieldset>
            </Col>
        </Row>
    );
};

export default StatisticsGrouping;
